// Password generator for admin "create new member" flow. 16 chars, no ambiguous
// characters (0/O/l/1/I), guaranteed to satisfy the signup rule set:
// length >= 8 + at least one letter + at least one digit.

const LOWERS = 'abcdefghijkmnopqrstuvwxyz';
const UPPERS = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%&*+-=';
const LEN = 16;

function pick(pool: string): string {
  const idx = Math.floor(Math.random() * pool.length);
  return pool.charAt(idx);
}

function shuffle(s: string): string {
  const arr = s.split('');
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = arr[i] as string;
    arr[i] = arr[j] as string;
    arr[j] = tmp;
  }
  return arr.join('');
}

export function generatePassword(): string {
  const guaranteed = pick(LOWERS) + pick(UPPERS) + pick(DIGITS) + pick(SYMBOLS);
  const pool = LOWERS + UPPERS + DIGITS + SYMBOLS;
  let rest = '';
  for (let i = 0; i < LEN - guaranteed.length; i++) rest += pick(pool);
  return shuffle(guaranteed + rest);
}
